import axios from 'axios'

export default {
  // 田中ID認証の再送メールは一旦保留(2020/08/04)
  // // API:5
  // async sendConfirmTanakaIdMail(tanaka_id) {
  //   return await mock.post(`users/send_confirm_tanaka_id_mail`, {
  //     tanaka_id: tanaka_id,
  //   })
  // },

  // API:6
  async confirmTanakaId(token) {
    return await axios.get('users/confirm_tanaka_id', {
      params: {
        confirmation_token: token,
      },
    })
  },
}
